// export const ADDRESS_API_KEY = "PCWDH-MQ3DC-MWSF2-WGFVR";
// export const ADDRESS_API_KEY = "PCW45-12345-12345-1234X"; // from my postcoderaccount

// loquate account faizal
export const ADDRESS_API_KEY = "JY38-ZJ96-NZ97-TR48"

// TESTING
// export const ADDRESS_API_KEY = "CG26-WC29-MA65-PM36"

export const ADDRESS_COUNTRY = "uk";

export const S3_ACCESS_KEY = "AKIATDPX5SPOPM6O5VOQ";
export const S3_SECRET_ACCESS_KEY = "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"